export const sectionAffiliationEnum = {
    mainPage: 1,
    productCard: 2,
    customPage: 3,
    registrationSummary: 4,
    registrationConfirmation: 5,
    cart: 6
};